export const SURGERY_BOARD_PATH = '/surgery-board';
export const BLOCK_SCHEDULE_PATH = '/surgery-board/block-schedule';
